<div class="mb-16">
    <div class="row">
        <div class="col-xs-12 mb-24">
            <h4 class="p-m-b text-center ttu">
                {{ 'legacy.itxReturnConfirmation.title' | translate }}
            </h4>
        </div>
        <p class="col-xs-12 title-xs mb-16">{{ 'legacy.itxReturnConfirmation.info' | translate }}</p>
        <p class="col-xs-12 title-xs mb-16">{{ 'legacy.itxReturnConfirmation.info2' | translate }}</p>
    </div>
</div>
